module.exports = __webpack_public_path__ + "static/media/student.ba1bcb8a.svg";